import React from 'react'
import { Typography } from '@mui/material'

const TemporaryAccessParagraphs = ({ paragraphs, values = {} }) => (
  <>
    {paragraphs.map(({ text, emphasis, suffix }) => (
      <Typography key={text} className="temporary-access-paragraph">
        {text}
        {emphasis && <strong>{values[emphasis]}</strong>}
        {suffix}
      </Typography>
    ))}
  </>
)

export default TemporaryAccessParagraphs
